import { inject, Injectable } from '@angular/core';
import moment from 'moment';
import { Utils } from 'axis-ui-generator';
import { DataStoreService } from '../../../../services/data-store.service';
import { insuranceTypeCheckBox } from 'src/app/features/fnol/config/fnol-constants';
@Injectable({
  providedIn: 'root'
})
export class ClaimtypeAbstractService {

  dataStoreService;
  momentDateFormat = 'DD-MM-YYYY';
  uiStructure;
  step2 = 'fnol-claimtype-details';
  mySettings51: any = {
    view_roundoff: false,
    thousands_separator: ',',
    decimal_separator: '.',
    fraction_size: '2',
    reg_exp: '^\d{1,3}(,\d{3})*(\.\d{2})?$',
    decimal: '',
    restrict: false
  };
  constructor() {
    this.dataStoreService = inject(DataStoreService);
  }

  /**
  *
  * @param name field label from Json
  * @param type Label /uiData
  * @param stepName step name
  * @returns
  */
  getData(name, type, stepName) {
    let resultData;
    this.uiStructure = this.dataStoreService.get(stepName).uiStructure;
    const uiData = this.dataStoreService.get(stepName).uiData;
    try {
      resultData = Utils.getFieldFromStructure(this.uiStructure, name);
    }
    catch (error) {
      resultData = '';
      return resultData;
    }
    if (type === 'label') {
      if (!resultData) {
        return '';
      }
      if (resultData?.type === 'checkbox') {
        return {
          key: resultData?.heading,
          value: resultData?.questionCd,
        }
      }
      return resultData;
    } else if (type === 'rpa') {
      if (resultData?.type === 'dropdown') {
        if (resultData.hasOwnProperty('isMultiSearchSelect')) {
          return uiData[name].map(i => i.id).join(',');
        } else if (!resultData.hasOwnProperty('isMultiSearchSelect')) {
          return uiData[name]?.id;
        }
      } else if (resultData?.type === 'radio') {
        const selectedOption = resultData.options.find(option => option.value === uiData[name]);
        return selectedOption ? selectedOption['label'] : uiData[name];
      }
      else if (resultData?.type === 'checkbox') {
        return (uiData[name] !== null && uiData[name] !== '' && uiData[name] !== 'No') ? 'Yes' : 'No';
      }

      else if (resultData?.type === 'text' || resultData?.type === 'datepicker' || resultData?.type === 'timepicker' || resultData?.type === null || resultData?.type === 'textarea') {
        return null;
      }
    } else {
      if (resultData?.type === 'datepicker' && uiData[name] !== 'Invalid date' && uiData[name] !== null && uiData[name] !== '') {
        return (uiData[name] !== null && uiData[name] !== '') ? moment(new Date(uiData[name])).format(this.momentDateFormat) : uiData[name];
      } else if (resultData?.type === 'timepicker') {
        return (uiData[name] !== null && uiData[name] !== '') && uiData[name]?.length > 5 ? moment(uiData[name]).format('hh:mm A') : uiData[name];
      } else if (resultData?.type === 'checkbox') {
        return (uiData[name] !== null && uiData[name] !== '' && uiData[name] !== 'No') ? $localize`:@@yesNor:Yes` : $localize`:@@noNor:No`;
      }
      else if (resultData?.type === 'dropdown') {
        if (resultData?.listType.id === 'multiSelect') {
          return uiData[name].map(i => i.name).join(',');
        }
        if (resultData.hasOwnProperty('isMultiSearchSelect')) {
          return uiData[name].map(i => i.name).join(',');
        } else if (!resultData.hasOwnProperty('isMultiSearchSelect')) {
          return uiData[name]?.name;
        }

      } else if (resultData?.type === 'radio') {
        const selectedOption = resultData.options.find(option => option.value === uiData[name]);
        return selectedOption ? selectedOption['label'] : uiData[name];
      }
      else if (resultData?.type === 'daterange') {
        const startDate = uiData[name].startDate;
        const endDate = uiData[name].endDate;
        const duration = moment(startDate).format('DD-MM-YYYY') + ' - ' + moment(endDate).format('DD-MM-YYYY');
        return duration;
      }
      else {
        return uiData[name];
      }
    }
  }

  /**
   * For US and CA.
   * @param fieldNames Array of fields to be captured.
   * @param formattedArray array to return the captured data.
   * @param index
   * @returns
   */
  pushFieldsWithNull({ fieldNames, formattedArray, index }: { fieldNames: string[]; formattedArray: any[]; index?: string }): { name: string; data: any }[] {
    fieldNames.forEach((name) => {
      const data = this.getData(name + index, '', this.step2);
      formattedArray.push({
        name: this.getData(name + index, 'label', this.step2)['label'],
        value: data,
      });
    });
    return formattedArray;
  }

  /**
   * For All except US and CA.
   * @param fieldNames Array of fields to be captured.
   * @param formattedArray array to return the captured data.
   * @param index
   * @returns
   */
  pushFieldsWithoutNull({ fieldNames, formattedArray, index }: { fieldNames: string[]; formattedArray: any[]; index?: string }): { name: string; data: any }[] {
    fieldNames.forEach((name) => {
      const data = this.getData(name + index, '', this.step2);
      if (data) {
        formattedArray.push({
          name: this.getData(name + index, 'label', this.step2)['label'],
          value: data,
        });
      }
    });
    return formattedArray;
  }

  buildDetailsWithoutNull({
    mainUIFieldName,
    fieldNames,
    conditionalFieldName,
  }: {
    mainUIFieldName: string;
    fieldNames: string[];
    conditionalFieldName?: string
  }) {

    // array to return
    let formattedArray = [];
    // uiStructure fields

    const container = Utils.getFieldFromStructure(
      this.dataStoreService.get(this.step2).uiStructure,
      mainUIFieldName
    ).fields;
    const uiData = this.dataStoreService.get(this.step2).uiData;
    // loop over fields
    for (let i = 0; i < container.length; i++) {
      const matches = container[i].name.match(/(\d+)/);
      const digit = matches?.[0];

      // a main if condition that if 'Yes', then do the rest
      if (conditionalFieldName) {
        if (uiData[conditionalFieldName] === 'Yes') {
          // array of nested fields to look for
          // loop over nested fields
          formattedArray = this.pushFieldsWithoutNull({ fieldNames, formattedArray, index: digit ? digit : '' });
        }
      } else {
        formattedArray = this.pushFieldsWithoutNull({ fieldNames, formattedArray, index: digit ? digit : '' });
      }
    }
    // the main data
    // return array
    return formattedArray;
  }

  buildDetailsWithNull({
    mainUIFieldName,
    fieldNames,
    conditionalFieldName,
  }: {
    mainUIFieldName: string;
    fieldNames: string[];
    conditionalFieldName?: string
  }) {

    // array to return
    let formattedArray = [];
    // uiStructure fields

    const container = Utils.getFieldFromStructure(
      this.dataStoreService.get(this.step2).uiStructure,
      mainUIFieldName
    ).fields;
    const uiData = this.dataStoreService.get(this.step2).uiData;
    // loop over fields
    for (let i = 0; i < container.length; i++) {
      const matches = container[i].name.match(/(\d+)/);
      const digit = matches?.[0];

      // a main if condition that if 'Yes', then do the rest
      if (conditionalFieldName) {
        if (uiData[conditionalFieldName] === 'Yes') {
          // array of nested fields to look for
          // loop over nested fields
          formattedArray = this.pushFieldsWithNull({ fieldNames, formattedArray, index: digit ? digit : '' });
        }
      } else {
        formattedArray = this.pushFieldsWithNull({ fieldNames, formattedArray, index: digit ? digit : '' });
      }
    }
    // the main data
    // return array
    return formattedArray;
  }

  /**
   * Reusable method to capture the data.
   * Common for all the countries.
   * @param data Radio button condition name.
   * @returns Array
   */
  captureData(data) {
    const personalAccidentDetails = Array.isArray(data) ? data : [data];
    let personalAccidentDetailsInfo = [];
    personalAccidentDetailsInfo = this.pushFieldsWithNull({ fieldNames: personalAccidentDetails, formattedArray: personalAccidentDetailsInfo, index: '' });
    return personalAccidentDetailsInfo;
  }

  fractureList(e) {
    let obj = {};
    if (this.getData(e, '', this.step2)) {
      obj = {
        'name': this.getData(e, 'label', this.step2)['label'],
        'value': this.getData(e, '', this.step2)
      }
    }
    return obj;
  }

  /**
   * This function will be used when getting the amount Value.
   * @param field
   * @param index
   * @param step
   * @returns
   */
  checkCustom(field, index, step, axisPipe) {
    if (this.getData(field + index, 'label', step)['type'] === 'custom' &&
      this.getData(field + index, 'label', step)['element'] === 'CurrencyDropdownComponent') {
      return this.getData(field + index, '', step)['phoneNumber'] ?
        this.getData(field + index, '', step)['phoneCode'].hasOwnProperty('label') ?
          this.getData(field + index, '', step)['phoneCode']['label'] + ' ' + axisPipe.transform(this.getData(field + index, '', step)['phoneNumber'].toString(), this.mySettings51) :
          this.getData(field + index, '', step)['phoneCode'] + ' ' + axisPipe.transform(this.getData(field + index, '', step)['phoneNumber'].toString(), this.mySettings51)
        : null
    }
    else {
      return this.getData(field + index, '', step);
    }
  }

  /**
   * This function will be used in the Treatment Cost Table.
   * @param num
   * @param locale
   * @returns
   */
  decimalConverter(num: string, locale: string): string {
    const convert2Num: number = parseFloat(num);
    const decimalNum = convert2Num.toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    if (decimalNum.substring(decimalNum.length - 3)[0] === ',') {
      const decimalNumber = decimalNum.replace(decimalNum.substring(decimalNum.length - 3)[0], '.');
      return decimalNumber;
    } else {
      return decimalNum;
    }
  }

  /**
  * For AU and NZ
  * @param value input string from the user selection on multi-select dropdown.
  * @returns the sorted string.
  */
  insuranceType(value) {
    const sortedArray = [];
    const inputArray = value.split(',');
    insuranceTypeCheckBox.forEach(constant => {
      inputArray.forEach(inputValue => {
        if (constant === inputValue) {
          sortedArray.push(inputValue)
        }
      });
    });
    return sortedArray.join(', ');
  }

  /**
   * For US and CA.
   * To filter the other container wether it's is required or not based on dropdown.
   * @param data Data contains one set of data of a container.
   * @returns
   */
  filterIfOther(data) {
    const hasOther = data.some(item => (item.name === 'Site of Fracture' || item.name === 'Type of Fracture' || item.name === 'Site of Dislocation') && item.value === 'Other');
    return hasOther ? data : data.filter(e => e.name !== 'Please provide details');
  }

  /**
   * For All the countries to capture Hospital and doctor information in PA
   * @returns
   * Hospital and Doctor Information section starts here.
   */
  hospitalDoctorInfo(type) {
    const uiData = this.dataStoreService.get(this.step2).uiData;
    if (uiData[`doctorInfo${type}`] === 'Yes' || uiData[`doctorInfo${type}`] === 'No') {
      const array = [{
        name: 'Hospital and Doctor Information',
        value: 'heading'
      }];
      const data = [...array, ...this.captureData(`doctorInfo${type}`), ...this.hospitalDocInfo(type, 'a')];
      return data;
    }
  }

  hospitalDocInfo(type, e?) {
    const travelInsurance = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, `addDoctor${type}Main`).fields;
    let travelArr = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    if (uiData[`doctorInfo${type}`] === 'Yes') {
      travelInsurance.forEach((card) => {
        card.fields.forEach((data, i) => {
        if (i > 0 && !e) {
          travelArr.push({
            'name': '',
            'value': ''
          });
        }
        data?.fields?.forEach((item) => {
          if (item.name.match(`mobileDoctor${type}`)) {
            travelArr.push(
              {
                'name': 'Contact Number',
                'value': uiData[item.name]?.phoneNumber?.length > 0 ? this.phoneNumberValidation(item.name) : ''
              }
            );
          }
          else {
            travelArr.push({
              'name': this.getData(item.name, 'label', this.step2)['label'],
              'value': this.getData(item.name, '', this.step2)
            });
          }
        });
      });
      });
    } else {
      travelArr = [];
    }
    return travelArr.filter(element => (element.name !== undefined));
  }
  // Hospital and Doctor Information section ends here.

  /**
   * For All countries expect UK.
   * @param e
   * @returns
   * PA Medical Leave / Weekly Indemnity starts here.
   */
  mediaclLeaveData(heading, type, e?) {
    const travelInsurance = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, `addLeave${type}Main`).fields;
    let travelArr = [];
    travelInsurance.forEach((card) => {
      card.fields.forEach((data, i) => {
      data?.fields?.forEach((item) => {
        travelArr.push({
          'name': this.getData(item.name, 'label', this.step2)['label'],
          'value': this.getData(item.name, '', this.step2)
        });
      });
      });
    });
    if (e && travelArr.length > 0) {
      const array = [{
        name: heading,
        value: 'heading'
      }];
      travelArr = [...array, ...travelArr];
    }
    return travelArr.filter(element => (element.name !== undefined))
  }
  // PA Medical Leave / Weekly Indemnity ends here.

  /**
   * For US and CA.
   * @param e
   * @returns
   * PA Permanent/Temporary Disability starts here.
   */
  PermanentDisablementData(e?) {
    const fields = ['dateOfDisability', 'typeDisability', 'otherCauseDisability'];
    let disabilityData = [];
    disabilityData = this.captureData(fields);

    if (e && disabilityData.length > 0) {
      disabilityData = [{
        name: 'Permanent or Temporary Disablement',
        value: 'heading'
      }, ...disabilityData];

    }
    return disabilityData;
  }
  // PA Permanent/Temporary Disability ends here.

  /**
   * For US and CA.
   * To capture data from the Hospital Cash section.
   * @param e
   * @returns Array of data related to Hospital Cash section.
   * PA Hospital Cash section starts here.
   */
  hospitalCashData() {
    const hospitalCash = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addHospitalCashMain').fields;
    const personalAccidentArray = [];
    personalAccidentArray.push({
      'name': 'Hospital Cash',
      'value': 'heading'
    });
    hospitalCash.forEach((card) => {
      card.fields.forEach((data, i) =>{
      data?.fields?.forEach((item) => {
        personalAccidentArray.push({
          'name': this.getData(item.name, 'label', this.step2)['label'],
          'value': this.getData(item.name, '', this.step2)
        });
      });
    });
    });
    return personalAccidentArray.filter(e => (e.name !== undefined));
  }
  // PA Hospital Cash section ends here.

  /**
   * For US and CA.
   * Reusable method for both Fracture and Dislocation Container.
   * @param main Main container name.
   * @param condition Radio button name.
   * @returns Array
   * PA Fracture/Dislocation section starts here.
   */
  fractureDislocation(main, condition) {
    const fractureDislocation = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, main).fields;
    let temp = [];
    let personalAccidentArray = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    if (uiData[condition] === 'Yes') {
      fractureDislocation.forEach((card) => {
        card.fields.forEach((data, i) =>{
        data?.fields?.forEach((item) => {
          temp.push({
            'name': this.getData(item.name, 'label', this.step2)['label'],
            'value': this.getData(item.name, '', this.step2)
          });
        });
        personalAccidentArray = [...personalAccidentArray, ...this.filterIfOther(temp)];
        temp = [];
      });
      });
    }
    return personalAccidentArray.filter(e => !(e.value === '' && e.name === 'Please provide details') && !(e.value === null && e.name === undefined));
  }
  // PA Fracture/Dislocation section ends here.


  /**
   * PA Other section common for all countries.
   * @param e
   * @returns
   * PA Other section starts here.
   */
  otherDeathData(type, e?) {
    let obj;
    const data = this.getData(`claimOther${type}`, '', this.step2);
    if (data) {
      obj = {
        'name': this.getData(`claimOther${type}`, 'label', this.step2)['label'],
        'value': data
      }
    }
    if (e && obj) {
      const array = [{
        name: 'Other',
        value: 'heading'
      }];
      obj = [...array, obj];
    }
    return obj;
  }
  // PA Other section ends here.

  /**
   * For US & CA & NZ & AU only
   * @param step
   * @returns
   * getUploadDetails section starts here.
   */
  getUploadDetailsData(step) {
    const obj = [];
    if (this.dataStoreService.get(step).uiData.customFileUpload) {
      const fileList = this.dataStoreService.get(step).uiData.customFileUpload.uploads;
      fileList.forEach((element, i) => {
        obj.push(
          {
            name: 'Upload' + (i + 1) + ':',
            value: element.name
          }
        );
      });
      return obj;
    } else {
      return obj;
    }
  }
  // getUploadDetails section ends here.

  /**
    * For All countries.
    * @returns getOtherDetails.
    * PA getOtherDetails section starts here.
    */
  getOtherDetailsData(claimFor, date) {
    const otherDetailsInfo = [];
    otherDetailsInfo.push(
      {
        name: this.getData('claimBenefits', 'label', this.step2)['label'] === 'Select Claim Type' ? 'What is the cause of your claim?' : '',
        value: this.dataStoreService.get(this.step2).uiData['claimBenefits']
      });
    otherDetailsInfo.push({
      name: this.getData(claimFor, 'label', this.step2)['label'],
      value: this.getData(claimFor, '', this.step2)
    });
    otherDetailsInfo.push({
      name: this.getData(date, 'label', this.step2)['label'],
      value: this.getData(date, '', this.step2)
    });
    return otherDetailsInfo;
  }

  /**
    * For AU and NZ only.
    * @returns personalaccidentclaimInfo.
    * PA personalaccidentclaimInfo section starts here.
    */
  personalaccidentclaimData() {
    const personalAccidentClaimPastInfo = Utils.getFieldFromStructure(this.uiStructure, 'addEntryMain').fields;
    const personalAccidentArray = [];
    personalAccidentArray.push(
      {
        name: this.getData('personalAccidentPast', 'label', this.step2)['label'],
        value: this.getData('personalAccidentPast', '', this.step2),
      }
    );
    personalAccidentClaimPastInfo.forEach((card) => {
      card.fields.forEach((data, i) =>{
      data?.fields?.forEach((item) => {
        personalAccidentArray.push({
          'name': this.getData(item.name, 'label', this.step2)['label'],
          'value': this.getData(item.name, '', this.step2)
        });
      });
      });
    });
    return personalAccidentArray.filter(e => (e.name !== undefined && e.name !== null));
  }
  // PA personalaccidentclaimInfo section ends here.

  phoneNumberValidation(controlName) {
    const data = this.dataStoreService.get(this.step2)['uiData'][controlName];
    if(data){
    return data['phoneNumber'] && data.length !== 0 ? this.getData(controlName, '', this.step2)['phoneCode'].hasOwnProperty('label') ? this.getData(controlName, '', this.step2)['phoneCode']['label'] + '-' + this.getData(controlName, '', this.step2)['phoneNumber'] : this.getData(controlName, '', this.step2)['phoneCode'] + '-' + this.getData(controlName, '', this.step2)['phoneNumber'] : '';
    }
  }
}